import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ApiService } from "src/app/api.service";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-asset-general",
	templateUrl: "./asset-general.component.html",
	styleUrls: ["./asset-general.component.scss"],
	imports: [FormsModule, ActionButtonComponent]
})
export class AssetGeneralComponent implements OnInit {
	private api = inject(ApiService);

	@Input()
	asset: APIResults.Asset;

	@Output()
	UpdateTree: EventEmitter<void> = new EventEmitter<void>();

	public orgConfigs: APIResults.AssetConfig[] = [];

	async ngOnInit(): Promise<void> {
		this.orgConfigs = await this.api.GetAssetConfigs(this.asset.organization_id);
	}

	public async UpdateAsset() {
		await this.api.UpdateAsset(this.asset.organization_id, this.asset.asset_id, { asset_name: this.asset.asset_name, asset_type_id: this.asset.asset_type_id, asset_serial_number: this.asset.asset_serial_number, sim_iccid: this.asset.sim_iccid, hw_serial_number: this.asset.hw_serial_number, mac_address: this.asset.mac_address, board_revision: this.asset.board_revision, gonedark_days: this.asset.gonedark_days, gonedark_suspend: this.asset.gonedark_suspend, hidden: this.asset.hidden, override_heading: this.asset.override_heading });
		this.UpdateTree.emit();
	}
}
